import styled, { css } from 'styled-components';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Icons from '../Icons';

export const Header = styled(DialogTitle)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--white);
  padding: 16px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  gap: 12px;

  .dsc-icon-wrapper {
    color: var(--antiFlashWhite2);
  }
`;

export const AttachmentInfo = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: var(--antiFlashWhite2);
  font-size: 14px;
  font-weight: 500;
`;

export const FileCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--antiFlashWhite2);
  font-size: 14px;
  font-weight: 500;
`;

const arrowStyles = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  font-size: 48px;
  pointer-events: ${({ $enabled }) => ($enabled ? 'initial' : 'none')};

  svg {
    color: var(--white);
    opacity: ${({ $enabled }) => ($enabled ? 0.8 : 0.3)};
    transition: opacity 0.2s ease;

    &:hover {
      opacity: ${({ $enabled }) => ($enabled ? 1 : 0.3)};
    }
  }
`;

export const ArrowRight = styled(Icons.NextArrow)`
  ${arrowStyles};
  right: 20px;
`;

export const ArrowLeft = styled(Icons.PrevArrow)`
  ${arrowStyles};
  left: 20px;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const LoadingIcon = styled(Icons.InProgress).attrs({ size: 14, rotate: true, color: 'var(--mainGreen)' })`
  position: absolute;
  top: -5px;
  right: -5px;
`;

export const DownloadIcon = styled(Icons.Download)`
  cursor: pointer;
`;

export const CloseIcon = styled(Icons.Close)`
  cursor: pointer;
`;

export const PreviewDialog = styled(Dialog)`
  .MuiBackdrop-root {
    background-color: unset;
  }
  .MuiDialogContent-root {
    align-content: center;
  }

  .MuiDialog-paper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: var(--modal-backdrop-bg, var(--roofGreen-600));
    backdrop-filter: blur(5px);
    max-width: unset;
    max-height: unset;
    margin: unset;
  }
`;

export const PreviewWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--antiFlashWhite2);
`;

export const Image = styled.img`
  width: inherit;
  height: inherit;
  max-width: 70%;
`;

// PDF Viewer Styles
export const PdfContainer = styled.div`
  .pg-viewer-wrapper {
    overflow-y: auto;
  }

  .pdf-viewer {
    width: 700px;
    height: 80vh;
  }

  .react-pdf__Page__canvas {
    margin-bottom: 32px;
  }
`;

// Text Viewer Styles
export const TextContainer = styled.div`
  background: var(--white);
  color: var(--darkPurple);
  border-radius: 8px;
  padding: 20px;
  max-width: 75vw;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const TextContent = styled.div`
  white-space: pre-wrap;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const StatusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
`;

// CSV Viewer Styles
export const CSVContainer = styled.div`
  background-color: var(--white);
  max-width: 75vw;
  max-height: 80vh;
  overflow: auto;
  border-radius: 8px;
  padding: 16px;
  color: var(--darkJungleGreen);
`;

const cellCss = css`
  min-width: 100px;
  padding: 8px;
  text-align: left;
  vertical-align: top;
`;

export const CSVTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  tbody {
    .header-row {
      border-bottom: 2px solid #333;

      td {
        ${cellCss}
        border-right: 1px solid #333;
        font-weight: 600;
        font-size: 14px;
        background-color: #f5f5f5;
      }
    }

    .data-row {
      border-bottom: 1px solid #ddd;

      &:hover {
        background-color: #f9f9f9;
      }

      td {
        ${cellCss}
        border-right: 1px solid #ddd;
        font-size: 12px;
        word-break: break-word;
      }
    }
  }
`;
